import { render, staticRenderFns } from "./BidItem.vue?vue&type=template&id=04812e71&scoped=true&"
import script from "./BidItem.vue?vue&type=script&lang=js&"
export * from "./BidItem.vue?vue&type=script&lang=js&"
import style0 from "./BidItem.vue?vue&type=style&index=0&id=04812e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04812e71",
  null
  
)

export default component.exports